import {createSlice} from '@reduxjs/toolkit'

import {Project} from 'airship/clients/wallet/types'
import APP_KEY_OR_COMPANY_ID from 'airship/modules/app_key'
import APP_NAME from 'airship/modules/app_name'
import pageContext from 'airship/modules/page-context'

import {CREATE_TICKET_ERROR_MESSAGE} from './constants'
import {createTicketThunk} from './thunks'
import {Urgency} from './types'

interface Context {
  project?: Project
}

const context = pageContext<Context>()

const projectId = context.project?.contextId
const projectName = context.project?.name
const appName = APP_NAME
const appKey = projectId ? '' : APP_KEY_OR_COMPANY_ID
const companyId = projectId ? APP_KEY_OR_COMPANY_ID : ''

export type Details = {
  url: string
  urgency?: Urgency
  appName?: string
  appKey?: string
  product?: string
  productLabel?: string
  issueDescription?: string
  browser?: string
  browserVersion?: string
  pushId?: string
  channelId?: string
  messageType?: string
  messageName?: string
  sdkFramework?: string
  sdkFrameworkVersion?: string
  subject?: string
  image?: string //base64
  imageName?: string
  projectId?: string
  projectName?: string
  companyId?: string
}

export type State = {
  loading: boolean
  details: Details
  supportLevel: string
  ticketNumber?: number
  errorMessage?: string
  imageError?: boolean
  isUnauthorized: boolean
  isDGCP: boolean
}

export const initialState: State = {
  loading: false,
  errorMessage: '',
  supportLevel: '',
  imageError: false,
  isUnauthorized: false,
  isDGCP: false,
  details: {
    appName,
    url: window.location.href,
    appKey,
    projectId,
    projectName,
    companyId,
  },
}

const detailsSlice = createSlice({
  name: 'details',
  initialState,
  reducers: {
    clearFields(state) {
      Object.assign(state, initialState)
    },
    updateDetails(state, {payload}) {
      state.details = {...state.details, ...payload}
    },
    clearErrorMessage(state) {
      state.errorMessage = ''
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTicketThunk.pending, (state) => {
        state.loading = true
      })
      .addCase(createTicketThunk.fulfilled, (state, {payload}) => {
        state.loading = false
        state.errorMessage = ''
        state.ticketNumber = payload.ticketNumber
        state.supportLevel = payload.supportLevel
        state.imageError = payload.imageError
        state.isDGCP = payload.isDGCP
      })
      .addCase(createTicketThunk.rejected, (state, action) => {
        action.payload?.statusCode === 403
          ? (state.isUnauthorized = true)
          : (state.errorMessage = CREATE_TICKET_ERROR_MESSAGE)
        state.loading = false
      })
  },
})

export default detailsSlice
